


































import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

import IrisViewer from '../components/viewer/IrisViewer.vue'

export default Vue.extend({
  components: { IrisViewer },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    logo: {
      type: String
    }
  },

  data() {
    return {
      dates: [] as string[],
      images: {} as any,
      loading: true,
      view: {} as any,
      project: {} as any,
      projectViews: [] as any[],
      unsubscribe: {
        view: () => null as any
      }
    }
  },

  computed: {
    sortedImages():{[key:string]: any[]} {
      return this.sortImages(this.images)
    }
  },

  methods: {
    sortImages(images) {
      Object.keys(images).forEach(key => {
        this.$schema.sort(images[key], ['original'])
      })
      return images
    },
    getView(id) {
      this.unsubscribe.view()
      this.unsubscribe.view = this.$db.collection('views').doc(id).onSnapshot(doc => {
        let view = {} as any
        if (doc.exists) {
          view = {_id: doc.id, ...doc.data()}
          this.view = view

          const enabledDates = view.enabledDates.sort((a,b) => a > b ? 1 : -1)
          this.dates = enabledDates
          const latestEnabled = enabledDates[enabledDates.length - 1]
          const date = new Date(latestEnabled)
          this.getImages(latestEnabled)
        }
      })
    },
    getImages(date) {
      if (this.view.storageService === 'aws-s3') {
        const startDate = new Date(date)
        const endDate = new Date(date)
        endDate.setDate(endDate.getDate()+1)
        window.console.log(`Getting images for view: ${this.id}, date: ${date}`)
        this.$db.collection('views').doc(this.id).collection('images')
        .where('dateCaptured', '>=', startDate)
        .where('dateCaptured', '<', endDate).get().then(snapshot => {
          window.console.log(`${snapshot.size} images received`)
          if (snapshot.size) {
            const images = [] as any[]

            snapshot.forEach(async doc => {
              const { bucket, prefix, dateCaptured, imgixURL, filename } = doc.data()
              images.push({
                _id: doc.id,
                original: imgixURL,
                thumbnail: imgixURL + '?w=320',
                meta: { filename: filename || "unknown", date: dateCaptured.toDate() }
              })
            })
            
            this.$set(this.images, date, images)
            this.loading = false
            this.$emit('ready')
            
          }
        }).catch(err => {
          window.console.log(err.message, err)
          alert(err.message || "An unknown error occurred, please refresh the page and try again.")
        })
      } else if (this.view.storageService === 'gcp-storage') {
        const request = {
          headers: { authorization: `Bearer ${window.localStorage.getItem('idToken')}` },
          method: 'GET',
          url: `${process.env.VUE_APP_IMG_URL}/getImageUrls?viewId=${this.id}&date=${date}`
        }
        axios(request).then(response => {
          this.$set(this.images, date, response.data)
        }).catch(err => {
          window.console.log(err)
          if (err.message) alert(err.message)
        })
      }
    },

    removeImage(image) {
      this.$db.collection('views').doc(this.id).collection('images').doc(image._id).delete().then(value => {
        window.console.log('Image successfully deleted.')
      }).catch(err => {
        alert(err.message)
      })
    },

    setLatestImage(image) {
      this.$db.collection('views').doc(this.id).update({
        latestImageURL: image
      }).then(value => {
        alert("Latest image successfully updated.")
      }).catch(err => {
        alert(err.message)
      })
    }
  },

  beforeDestroy() {
    this.unsubscribe.view()
  },

  created() {
    this.getView(this.id)
  }
})
